import { useAxios } from '../../utils/axiosConfig';
import { useNotification } from "../../contexts/NotificationContext";
import { getErrorMessage } from '../../utils/errorMessageUtils';
import config from '../../contexts/ConfigContext';
import { LabelingModel } from 'services/BatchServices';

export interface SearchFilterRequestModel {
    PeriodStartDate: string | null;
    PeriodEndDate: string | null;
    Sources: number[];
    Channels: number[];
    Countries: number[];
    UniqueId: string;
}

export interface ImportMissingsModel {
    ImportAll: boolean;
    UniqueIds: string[];
    PeriodStartDate: string;
    PeriodEndDate: string;
}

export class SearchMissingsService {

    axios = useAxios();
    // Define the notification hook
    notification = useNotification();

    async ExecuteSearchbyFilters(filterModel: SearchFilterRequestModel, file: File | null): Promise<any> {
        try {
            // 1. Create a new formdata to include file and filters
            const formData = new FormData();
            
            // 2. Append the file as is.
            if (file) {
                formData.append('file', file);
            }

            // 3. Append the filterModel as a JSON string.
            formData.append('filters', JSON.stringify(filterModel));

            // 4. Send the FormData object. Axios will automatically set the correct Content-Type.
            const response = await this.axios.post(config.API_LABELING_URL + "/api/Documents/SearchMissings", formData);
            if(response.data && response.data.length === 2500){
                // Display a Telerik orange banner instead of a notification
                const bannerElement = document.createElement('div');
                bannerElement.style.backgroundColor = 'orange';
                bannerElement.style.color = 'white';
                bannerElement.style.padding = '10px';
                bannerElement.style.position = 'fixed';
                bannerElement.style.top = '0';
                bannerElement.style.width = '100%';
                bannerElement.style.textAlign = 'center';
                bannerElement.style.zIndex = '1000';
                bannerElement.textContent = "Warning: The result set is limited to 2500 records. Please refine your search criteria for more specific results.";
                
                document.body.appendChild(bannerElement);

                const closeButton = document.createElement('button');
                closeButton.textContent = '×';
                closeButton.style.marginLeft = '10px';
                closeButton.style.backgroundColor = 'transparent';
                closeButton.style.color = 'white';
                closeButton.style.border = 'none';
                closeButton.style.cursor = 'pointer';
                closeButton.style.fontSize = '16px';

                closeButton.addEventListener('click', () => {
                    document.body.removeChild(bannerElement);
                });

                bannerElement.appendChild(closeButton);
             }
            return response.data;
        }
        catch (error:any) {
            if(error?.response?.status === 422 || error?.response?.status === 400){
                this.notification.showNotification("Error executing search: " + error.response.data?.detail, 'warning');
            }
            else{
                this.notification.showNotification(getErrorMessage(error), 'error');
            }
            throw error;
        }
    }

    async ImportMissingDocuments(importModel: ImportMissingsModel): Promise<any> {
        try {
            const response = await this.axios.post(config.API_LABELING_URL + "/api/Documents/ImportMissing", importModel);
            return response.data;
        }
        catch (error:any) {
            if(error?.response?.status === 422 || error?.response?.status === 400){
                this.notification.showNotification("Error importing missing documents: " + error.response.data?.detail, 'warning');
            }
            else{
                this.notification.showNotification(getErrorMessage(error), 'error');
            }
            throw error;
        }
    }
    
    async GetDocument(documentId?: number): Promise<LabelingModel> {
        try {
                const response = await this.axios.get(config.API_LABELING_URL + "/api/Documents/LabelingModelByDocumentId/" + (documentId?documentId:""));
                return response.data;
            }
        catch (error:any) {
            this.notification.showNotification(getErrorMessage(error), 'error');
            throw error;
        }
    }
    
    async EnrichDocument(labelingModel: LabelingModel): Promise<LabelingModel> {
        try {
                const response = await this.axios.post(config.API_LABELING_URL + "/api/Documents/LabelingModelEnrichment/" , labelingModel);
                return response.data;
            }
        catch (error:any) {
            this.notification.showNotification(getErrorMessage(error), 'error');
            throw error;
        }
    }
    
}